import { IntentAdd } from '@fox/finance';
import React from 'react';
import { AddPaymentWrapperProps } from '../contracts';
import { useIntent } from './use-intent';

export const CardIntentWrapper: React.FC<AddPaymentWrapperProps> = props => {
	const useLinkedOrganisationData = props.meta?.['useLinkedOrganisationData'] == true;
	const { completeCard, setupIntent } = useIntent(props.provider, useLinkedOrganisationData);
	return <IntentAdd completeIntent={completeCard} getIntent={setupIntent} {...props} />;
};
